export const FORM_FIELDS = {
  SIGN_IN: {
    EMAIL: "email",
    PASSWORD: "password",
  },

  SIGN_UP: {
    EMAIL: "email",
    PASSWORD: "password",
  },

  EVENTS: {
    NAME: "name",
    LOCATION: "location",
    DATE: "date",
    TIME: "time",
    DESCRIPTION: "description",
    ACTIVE: "active",
    CHECK: "checkdata",
    RADIO: "radiodata",
  },

  EMPLOYEE: {
    GENERAL_INFO: {
      NAME_IN_ENGLISH: "nameEn",
      NAME_IN_BANGLA: "nameBn",
      EMPLOYEE_ID: "employeeCode",
      EMPLOYEE_TYPE: "employeeTypeId",
      EMPLOYMENT_TYPE: "employmentTypeId",
      NID_NO: "nid",
      MOBILE_NO: "mobileNumber",
      EMAIL: "email",
      DATE_OF_BIRTH: "dateOfBirth",
      GENDER: "genderIdStr",
      RELIGION: "religionId",
      HOME_DISTRICT: "homeDistrictId",
      MARITAL_STATUS: "maritalStatusId",
      BLOOD_GROUP: "bloodGroupId",
      FREEDOM_FIGHTER: "isFreedomFighter",
      DATE_OF_DEATH: "dateOfDeath",
      RANK_ID: "rankId",
      RANK: "rank",
      BATCH: "batch",
      POSTING_PLACE: "postingPlace",
      BASIC_SALARY: "basicSalary",
      WORKING_PLACE: "workingPlace",
      WING_DESK_IO_E0: "unitId",
      DESIGNATION: "positionId",
      GRADE: "gradeId",
      POSITION: "unitPositionId",
      ORDER_DATE: "orderDate",
      JOINING_DATE: "joiningDate",
      DATE_OF_RESPONSIBILITY_TAKEOVER: "responsibilityDate",
      PRL_DATE: "prlDate",
      CONFIRMATION_GO_DATE: "confirmationGoDate",
      GO_DATE: "goDate",
      GO_MEMO_NO: "goMemorialNo",
      LAST_PROMOTION_DATE: "lastPromotionDate",
      DEPUTATION_DATE: "deputationDate",
      CONTRACT_EXPIRY_DATE: "contractExpDate",
      PROBATION_END_DATE: "probationEndingDate",
      ORGANIZATION: "organization",
      ON_PROBATION: "onProbation",
      UPLOAD_CERTIFICATE: "uploadCertificate",
      SUPPORTING_DOCUMENTS: "supportingDocuments",
    },
    ATTACHED_FILES: {
      UPLOAD_PHOTO: "photo",
      UPLOAD_SEAL: "seal",
      UPLOAD_SIGNATURE: "signature",
      OTHER_DOC: {
        DOCUMENT_NAME: "documentName",
        DATE: "date",
        MEMORIAL_NO: "memorialNo",
        REMARKS: "remarks",
        UPLOAD_DOCUMENT: "attachmentDocument",
      },
    },
    FAMILY_INFO: {
      PARENT: {
        FATHER_NAME: "fathersName",
        MOTHER_NAME: "mothersName",
      },
      SPOUSE: {
        SPOUSE_NAME: "nameEn",
        SPOUSE_HOME_DISTRICT: "districtId",
        SPOUSE_OCCUPATION: "occupation",
        SPOUSE_ORGANIZATION: "organization",
        SPOUSE_DESIGNATION: "designation",
        SPOUSE_LOCATION: "location",
      },
      CHILDREN: {
        CHILDREN_NAME: "nameEn",
        CHILDREN_GENDER: "genderIdStr",
        CHILDREN_DOB: "dateOfBirth",
      },
      EMERGENCY_CONTACT: {
        NAME: "nameEn",
        RELATION: "relation",
        CONTACT: "contact",
      },
      PERMANENT_ADDRESS: {
        VILLAGE_HOUSE_ROAD: "villageHouseRoad",
        POST_OFFICE: "postOffice",
        POLICE_STATION: "policeStation",
        DISTRICT: "districtId",
        TELEPHONE: "telephoneNo",
        MOBILE: "mobileNo",
      },
      PRESENT_ADDRESS: {
        VILLAGE_HOUSE_ROAD: "villageHouseRoad",
        POST_OFFICE: "postOffice",
        POLICE_STATION: "policeStation",
        DISTRICT: "districtId",
        TELEPHONE: "telephoneNo",
        MOBILE: "mobileNo",
      },
      RATION: {
        ELIGIBLE_RATION_NUMBER: "eligibleRationNumber",
        RATION_CARD_NUMBER: "rationCardNumber",
        OFFICE_ID: "officeId",
        RECEIVING_POINT: "receivingPoint",
        TOTAL_ELIGIBLE_MEMBER_FOR_RATION: "totalEligibleMemberForRation",
        RATION_LAST_DATE: "rationLastDate",
        OFFICE_NAME: "officeName",
        OFFICE_ADDRESS: "officeAddress",
        OFFICE_NAME_BN: "officeNameBn",
        OFFICE_ADDRESS_BN: "officeAddressBn",
        DOCUMENTS: "documents",
      },
    },
    QUALIFICATION: {
      EDUCATION: {
        NAME_OF_INSTITUTION: "institutionName",
        SUBJECT: "subject",
        DEGREE: "degree",
        PASSING_YEAR: "passingYear",
        RESULT: "result",
        UPLOAD_CERTIFICATE: "document",
      },
      LOCAL_TRAINING: {
        COURSE_TITLE: "courseTitle",
        INSTITUTION: "institution",
        TYPE: "type",
        POSITION: "position",
        FROM_DATE: "fromDate",
        TO_DATE: "toDate",
        DURATION: "duration",
        UPLOAD_CERTIFICATE: "documents",
      },
      FOREIGN_TRAINING: {
        COURSE_TITLE: "courseTitle",
        COUNTRY: "countryId",
        TYPE: "type",
        POSITION: "position",
        FROM_DATE: "fromDate",
        TO_DATE: "toDate",
        DURATION: "duration",
        UPLOAD_CERTIFICATE: "documents",
      },
      ADDITIONAL_PROFESSIONAL_QUALIFICATION: {
        QUALIFICATION: "qualification",
        UPLOAD_DOCUMENT: "documents",
      },
      PUBLICATIONS: {
        BOOK: "book",
        JOURNAL: "journals",
        DESCRIPTION: "description",
        DATE: "date",
        UPLOAD_DOCUMENT: "documents",
      },
      HONOURS: {
        HONORARIUM: "honorarium",
        GROUND: "ground",
        AWARDER: "award",
        DATE: "date",
      },
      REWARDS: {
        NAME: "title",
        DESCRIPTION: "description",
        UPLOAD_DOCUMENT: "documents",
        DATE: "date",
        MEMORIAL_NO: "memorialNo",
        REMARKS: "remarks",
      },
    },

    DISCIPLINE: {
      REASON_FOR_PUNISHMENT: "offenceNature",
      IS_SUSPEND: "isSuspend",
      REASON_OF_SUSPEND: "reasonOfSuspend",
      SUSPEND_START_DATE: "suspendStartDate",
      SUSPEND_END_DATE: "suspendEndDate",
      SUSPEND_FINISH_DATE: "suspendFinishedDate",
      IS_SUSPEND_ENDED: "isSuspendEnded",
      PUNISHMENT_DETAILS: "punishmentDetails",
      DATE: "date",
      REMARKS: "remarks",
    },
    SERVICES: {
      SERVICE_HISTORY: {
        POSITION: "position",
        ACC_SERVICE_DATE: "accServiceDate",
        GAZETTED_DATE: "gazettedDate",
        CONFIRMED_DATE: "confirmationDate",
        SENIORITY_DATE: "seniorityDate",
      },
      OTHER_SERVICES: {
        NAME_OF_EMPLOYER: "employerName",
        ADDRESS: "address",
        TYPE_OF_SERVICE: "serviceType",
        POSITION: "position",
        FROM_DATE: "fromDate",
        END_DATE: "toDate",
        PAY_SCALE_FROM: "fromPay",
        PAY_SCALE_TO: "toPay",
      },
      PROMOTION_PARTICULARS: {
        POSITION: "position",
        RANK: "gradeName",
        PROMOTION_DATE: "promotionDate",
        G_O_DATE: "goDate",
        NATURE_OF_PROMOTION: "promotionNature",
        GRADE: "gradeId",
        PAY_SCALE_FROM: "payScaleMin",
        PAY_SCALE_TO: "payScaleMax",
      },
    },
    POSTINGS: {
      ABROAD_POSTING: {
        COUNTRY: "countryId",
        PURPOSE: "purpose",
        FROM_DATE: "fromDate",
        TO_DATE: "toDate",
      },
      ATTACHMENT_POSTING: {
        POST: "apPost",
        NAME_OF_OFFICE: "apOfficeName",
        WING: "apWing",
        DIST: "apDistrict",
        FROM_DATE: "apFrom",
        TO_DATE: "apTo",
      },
      CONTRACTUAL_POSTING: {
        POST: "cpPost",
        NAME_OF_OFFICE: "cpOfficeName",
        WING: "cpWing",
        DIST: "cpDistrict",
        FROM_DATE: "cpFrom",
        TO_DATE: "cpTo",
      },
      DEPUTATION_POSTING: {
        POST: "post",
        ORGANIZATION: "organization",
        FROM_DATE: "fromDate",
        TO_DATE: "toDate",
      },
      POSTING_RECORDS: {
        POST: "post",
        OFFICE_ID: "officeId",
        UNIT_ID: "unitId",
        DISTRICT_ID: "districtId",
        FROM_DATE: "fromDate",
        TO_DATE: "toDate",
        GRADE: "gradeName",
        BASIC_SALARY: "basicSalary",
        PAY_SCALE_MIN: "payScaleMin",
        PAY_SCALE_MAX: "payScaleMax",
      },
      FOREIGN_TRAVEL: {
        COUNTRY: "countryId",
        PURPOSE: "purpose",
        FROM_DATE: "fromDate",
        TO_DATE: "toDate",
      },
    },

    ACR_SUMMARY: {
      BASIC_INFO: {
        GRADATION_NO: "gradationNo",
        NAME: "name",
        DESIGNATION: "designation",
        DATE_OF_BIRTH: "dateOfBirth",
        WORKING_PLACE: "workingPlace",
        JOINING_DATE: "joiningDate",
        CONFIRMATION_GO_DATE: "confirmationGODate",
        DATE_OF_JOINING_THE_POST_OF_ASSISTANT_DIRECTOR: "dateOfJoinAD",
        DATE_OF_DEPARTURE_OF_PRL: "dateOfDeparturePRL",
        EDUCATIONAL_QUALIFICATION: "educationalQualification",
        AVERAGE_MARKS_OF_ACR: "averageMarksOfAcr",
        RESULT_OF_DIVISIONAL_EXAM: "resultOfDivisionalExam",
        WHETHER_ABOVE_50_YEARS_APPLIED_WITHOUT_EXAMINATION_FOR_PROMOTION:
          "whetherAbove50YearsAppliedWithoutExaminationForPromotion",
        DIVISIONAL_ACTION_CASE_INFORMATION: "divisionalActionOrCaseInformation",
      },
      ADD_CONFIDENTIAL_REPORT: {
        YEAR: "year",
        STATUS: "acrPerformanceStatus",
        ELIGIBILITY: "acrPerformanceEligibility",
        COMMENT: "acrPerformanceComment",
        YEAR_BASED_OBTAINED_NUMBER_OF_ACR: "yearBasedObtainedNumberOfAcr",
        APPRAISAL_OF_THE_APPLICANT_OFFICER: "appraisalOfTheApplicantOfficer",
        COUNTERSIGNING_OFFICER_EVALUATION: "counterSigningOfficerEvaluation",
        UPLOAD_ACR: "acrDocuments",
      },
    },
    APR: {
      UPDATE_APR_DOCUMENT: {
        YEAR: "year",
        MARK: "mark",
        UPLOAD_APR: "aprDocuments",
        UPLOAD_KPI: "kpiDocuments",
      },
    },
    DOSSIER: {
      ADD_DOSSIER: {
        NAME: "name",
        DATE: "date",
        REMARKS: "remarks",
        DOCUMENTS: "dossierDocuments",
      },
    },
    EXTRA_RESPONSIBILITY: {
      TITLE: "extraResponsibility",
      WING_DESK_IO_E0: "unitId",
      DESIGNATION: "positionId",
      GRADE: "gradeId",
      POSITION: "designationId",
      TYPE: "type",
      DESCRIPTION: "description",
      START_DATE: "inchargeStartDate",
      END_DATE: "inchargeEndDate",
      PASSWORD: "password",
      USERNAME: "username",
    },
    FILE_INQUIRY: {
      FILE_TYPE: "fileType",
      SUBJECT: "subject",
      FILE_FROM_DATE: "fileFromDate",
      STATUS: "status",
      PERFORMANCE_EVALUATION: "performanceEvaluation",
      UNIQUE_NAME: "uniqueName",
    },
  },

  TRANSFER: {
    TRANSFER_REQUEST_INFO: {
      NAME: "name",
      CURRENT_POSTING: "currentPosting",
      TRANSFERRED_POSTING: "transferredPosting",
      ASSET_HANDOVER_LIST: "assetHandoverList",
      UPLOAD_SUPPORTING_DOCUMENT: "uploadSupportingDocument",
    },
    TRANSFER_DETAILS: {
      COMMENT: "comment",
      POSITION: "unitPositionId",
      RELEASE_DATE: "releaseDate",
      JOINING_DATE: "joiningDate",
      TO_DATE: "toDate",
      BASIC_SALARY: "basicSalary",
      PAY_SCALE_MIN: "payScaleMin",
      PAY_SCALE_MAX: "payScaleMax",
      LETTER: "letter",
      TRANSFER_DOCS: "transferOrderDocs",
      ASSET_DOCS: "assetHandOverDocs",
      SUPPORTING_DOCS: "supportingDocs",
      NOC_DOCS: "nocDocs",
      JOINING_LETTER_DOCS: "joiningLetterDocs",
      WING_DESK_IO_E0: "unitId",
      DESIGNATION: "positionId",
      GRADE: "gradeId",
      EMPLOYMENT_TYPE: "employmentTypeId",
    },
  },

  INTERCHANGE_TRANSFER: {
    SOURCE_EMPLOYEE_NAME: "sourceEmployee-name",
    SOURCE_EMPLOYEE_CURRENT_POSTING: "sourceEmployee-currentPosting",
    SOURCE_EMPLOYEE_TRANSFERRED_POSTING: "sourceEmployee-transferredPosting",
    SOURCE_EMPLOYEE_ASSET_HANDOVER_LIST: "sourceEmployee-assetHandoverList",
    SOURCE_EMPLOYEE_UPLOAD_SUPPORTING_DOCUMENT:
      "sourceEmployee-uploadSupportingDocument",
    SOURCE_EMPLOYEE_POSITION: "sourceEmployee-unitPositionId",
    SOURCE_EMPLOYEE_RELEASE_DATE: "sourceEmployee-releaseDate",
    SOURCE_EMPLOYEE_JOINING_DATE: "sourceEmployee-joiningDate",
    SOURCE_EMPLOYEE_TO_DATE: "sourceEmployee-toDate",
    SOURCE_EMPLOYEE_BASIC_SALARY: "sourceEmployee-basicSalary",
    SOURCE_EMPLOYEE_PAY_SCALE_MIN: "sourceEmployee-payScaleMin",
    SOURCE_EMPLOYEE_PAY_SCALE_MAX: "sourceEmployee-payScaleMax",
    SOURCE_EMPLOYEE_LETTER: "sourceEmployee-letter",
    SOURCE_EMPLOYEE_TRANSFER_DOCS: "sourceEmployee-transferOrderDocs",
    SOURCE_EMPLOYEE_ASSET_DOCS: "sourceEmployee-assetHandOverDocs",
    SOURCE_EMPLOYEE_SUPPORTING_DOCS: "sourceEmployee-supportingDocs",
    SOURCE_EMPLOYEE_NOC_DOCS: "sourceEmployee-nocDocs",
    SOURCE_EMPLOYEE_JOINING_LETTER_DOCS: "sourceEmployee-joiningLetterDocs",
    SOURCE_EMPLOYEE_WING_DESK_IO_E0: "sourceEmployee-unitId",
    SOURCE_EMPLOYEE_DESIGNATION: "sourceEmployee-positionId",
    SOURCE_EMPLOYEE_GRADE: "sourceEmployee-gradeId",
    SOURCE_EMPLOYEE_EMPLOYMENT_TYPE: "sourceEmployee-employmentTypeId",

    TARGET_EMPLOYEE_NAME: "targetEmployee-name",
    TARGET_EMPLOYEE_CURRENT_POSTING: "targetEmployee-currentPosting",
    TARGET_EMPLOYEE_TRANSFERRED_POSTING: "targetEmployee-transferredPosting",
    TARGET_EMPLOYEE_ASSET_HANDOVER_LIST: "targetEmployee-assetHandoverList",
    TARGET_EMPLOYEE_UPLOAD_SUPPORTING_DOCUMENT:
      "targetEmployee-UploadSupportingDocument",
    TARGET_EMPLOYEE_COMMENT: "targetEmployee-comment",
    TARGET_EMPLOYEE_POSITION: "targetEmployee-unitPositionId",
    TARGET_EMPLOYEE_RELEASE_DATE: "targetEmployee-releaseDate",
    TARGET_EMPLOYEE_JOINING_DATE: "targetEmployee-joiningDate",
    TARGET_EMPLOYEE_TO_DATE: "targetEmployee-toDate",
    TARGET_EMPLOYEE_BASIC_SALARY: "targetEmployee-basicSalary",
    TARGET_EMPLOYEE_PAY_SCALE_MIN: "targetEmployee-payScaleMin",
    TARGET_EMPLOYEE_PAY_SCALE_MAX: "targetEmployee-payScaleMax",
    TARGET_EMPLOYEE_LETTER: "targetEmployee-letter",
    TARGET_EMPLOYEE_TRANSFER_DOCS: "targetEmployee-transferOrderDocs",
    TARGET_EMPLOYEE_ASSET_DOCS: "targetEmployee-assetHandOverDocs",
    TARGET_EMPLOYEE_SUPPORTING_DOCS: "targetEmployee-supportingDocs",
    TARGET_EMPLOYEE_NOC_DOCS: "targetEmployee-nocDocs",
    TARGET_EMPLOYEE_JOINING_LETTER_DOCS: "targetEmployee-joiningLetterDocs",
    TARGET_EMPLOYEE_WING_DESK_IO_E0: "targetEmployee-unitId",
    TARGET_EMPLOYEE_DESIGNATION: "targetEmployee-positionId",
    TARGET_EMPLOYEE_GRADE: "targetEmployee-gradeId",
    TARGET_EMPLOYEE_EMPLOYMENT_TYPE: "targetEmployee-employmentTypeId",

    COMMENT: "comments",
  },

  RETIREMENT: {
    BASIC_INFO: {
      NAME: "nameEn",
      CURRENT_POSTING: "postingPlace",
      RETIREMENT_DATE: "retirementDate",
      JOINING_DATE: "joiningDate",
      SERVICE_PERIOD: "servicePeriod",
    },
    SUPPORTING_DOCUMENT: {
      EMPLOYEE_SUPPORTING_DOCUMENT: "retirementDetailsEmpDocuments",
      HR_SUPPORTING_DOCUMENT: "retirementDetailsHrDocuments",
    },
    RICH_TEXT_EDITOR: "letter",
    MODAL: {
      INPUT: "comment",
      CHECK: "checkboxValue",
    },
  },

  DECEASED: {
    BASIC_INFO: {
      NAME: "nameEn",
      EMPLOYEE_ID: "employeeId",
      EMERGENCY_CONTACT: "emergencyContactNumber",
      TIME: "time",
      DEATH_DATE: "deathDate",
      DESCRIPTION: "description",
    },
    SUPPORTING_DOCUMENT: "documents",
    MODAL: {
      INPUT: "comments",
    },
  },

  TERMINATION: {
    BASIC_INFO: {
      NAME: "nameEn",
      EMPLOYEE_ID: "employeeId",
      TERMINATE_REASON: "terminateReason",
      TERMINATE_DATE: "terminateDate",
      DESCRIPTION: "description",
    },
    SUPPORTING_DOCUMENT: "documents",
    MODAL: {
      INPUT: "comments",
    },
  },

  RELEASE: {
    BASIC_INFO: {
      NAME: "nameEn",
      RELEASE_DATE: "date",
      JOINING_DATE: "joiningDate",
      SERVICE_PERIOD: "servicePeriod",
      REMARKS: "remarks",
      DESCRIPTION: "description",
    },
    SUPPORTING_DOCUMENT: "documents",
    MODAL: {
      INPUT: "comments",
    },
  },

  LEAVE: {
    BASIC_INFO: {
      LEAVE_TYPE: "leaveTypeId",
      LEAVE_NATURE: "leaveNatureId",
      FROM_DATE: "startDate",
      TO_DATE: "endDate",
      TOTAL_DAYS: "leaveDaysCount",
      DELEGATED_EMPLOYEE_NAME: "delegatedEmployeeId",
      DELEGATED_EMPLOYEE_DESIGNATION: "delegatedEmployeeDesignation",
      ADDRESS: "contactAddressOnLeave",
      REASON: "leaveReason",
    },
    SUPPORTING_DOCUMENT: "leaveDocuments",
    MODAL: {
      COMMENT: "comment",
      CHECK: "checkboxValue",
      DESIGNATION: "designation",
      FILE_ON_HAND: "responsiblePerson",
    },
    SEND_FOR_APPROVAL: {
      DESIGNATION: "designation",
      FILE_ON_HAND: "responsiblePerson",
      COMMENT: "description",
    },
  },

  UPDATE_LEAVE: {
    TOTAL_LEAVE: "totalLeaveCount",
    TAKEN_LEAVE: "takenLeaveCount",
    REMAINING_LEAVE: "leaveBalanceCount",
  },

  LEAVE_SETTINGS: {
    SHORT_FORM: "shortForm",
    NAME: "name",
    NAME_BN: "nameBn",
    MAX_DURATION: "maxDuration",
  },

  PROMOTION: {
    MODAL: {
      NAME: "groupName",
    },
  },

  INITIATE_PROMOTION: {
    CURRENT_POSITION: {
      POSITION: "positionId",
      POSTING: "officeName",
      GRADE: "gradeId",
    },
    RECOMMENDED_POSITION: {
      POSTING: "posting",
      NAME_OF_OFFICE: "officeId",
      DEPARTMENT: "unitId",
      DISTRICT: "district",
      POST: "recommendedPositionId",
      POSITION: "unitPositionId",
      GRADE: "recommendedGradeId",
      JOINING_DATE: "fromDate",
      TO_DATE: "toDate",
      GO_DATE: "goDate",
      GO_NO: "goNo",
      BASIC_SALARY: "basicSalary",
      NATURE_OF_PROMOTION: "natureOfPromotion",
      PAY_SCALE_MIN: "payScaleMin",
      PAY_SCALE_MAX: "payScaleMax",
    },
    INITIATE_MODAL: {
      DEPARTMENT: "modalDepartmentId",
      POST: "modalPostId",
      POSITION: "modalPositionId",
      GRADE: "modalGradeId",
    },
    RECOMMEND_MODAL: {
      COMMENT: "comment",
    },
    ACTION_MODAL: {
      COMMENT: "comment",
    },
    PROMOTION_SCORE: "examinationScore",
    SUPPORTING_DOCUMENT: "uploadDocument",
    LETTER: "letter",
    GROUP_NAME: "name",
  },

  ORGANIZATION: {
    PROMOTIONS: {
      PERSONAL: {
        NAME: "name",
        CURRENT_POSITION: "currentPosition",
        CURRENT_POSTING: "currentPosting",
        CURRENT_EMPLOYEE_GRADE: "currentEmployeeGrade",
        PROMOTION_EXAMINATION_SCORE: "promotionExaminationScore",
      },
      SUPPORTING_DOCS: {
        DOCUMENT_NAME: "documentName",
        DESCRIPTION: "description",
        UPLOAD_DOCUMENT: "uploadDocument",
      },
      RICH_TEXT: "richContents",
    },
  },

  ATTENDANCE: {
    RICH_TEXT_EDITOR: "richTextEditor",
    START_DATE: "startDate",
    END_DATE: "endDate",
  },

  PROVIDENT_FUND: {
    CREATE_NEW_LOAN: {
      LOAN_ID: "loanId",
      LOAN_AMOUNT: "loanAmount",
      LOAN_ISSUE_DATE: "loanIssueDate",
      LOAN_APPLICATION: "approvedGpfLoanApplication",
      DOCUMENT: "associateDocuments",
    },
    CREATE_NEW_INSTALLMENT: {
      INSTALLMENT_AMOUNT: "installmentAmount",
      INSTALLMENT_DATE: "date",
      INSTALLMENT_FILE_NAME: "fileName",
      DOCUMENT: "installment",
    },
  },

  RESIGNATION: {
    BASIC_INFO: {
      NAME: "nameEn",
      CURRENT_POSTING: "postingPlace",
      RESIGNATION_DATE: "resignationsDate",
      JOINING_DATE: "joiningDate",
      SERVICE_PERIOD: "servicePeriod",
    },
    SUPPORTING_DOCUMENT: {
      EMPLOYEE_SUPPORTING_DOCUMENT: "resignationsDetailsEmpDocuments",
      HR_SUPPORTING_DOCUMENT: "resignationsDetailsHrDocuments",
    },
    RICH_TEXT_EDITOR: "letter",
    MODAL: {
      INPUT: "comment",
      CHECK: "checkboxValue",
    },
  },

  HRM_SETTINGS: {
    CREATE_OFFICE: {
      NAME: "name",
      NAME_BN: "nameBn",
      ADDRESS: "address",
      ADDRESS_BN: "addressBn",
      TYPE: "type_id",
      DIVISION: "division_id",
      DISTRICT: "district_id",
    },
  },

  INVENTORY: {
    MAINTENANCE: {
      CATEGORY: "categoryId",
      GROUP: "groupId",
      BRAND: "brandId",
      NAME: "assetItemId",
      ISSUE_NAME: "issueName",
      ISSUE_DETAILS: "issueDetails",
      EMPLOYEE_ID: "employeeId",
      BOOK_START_DATE: "bookStartDate",
      BOOK_END_DATE: "bookEndDate",
    },
    ROOM_CONFERENCE: {
      OFFICE: "officeId",
      ROOM: "roomId",
      BUILDING: "buildingId",
      MEETING_PURPOSE: "meetingPurpose",
      REFRESHMENT_DETAILS: "refreshmentDetails",
      TOTAL_ATTENDEES: "totalAttendance",
      BOOKING_DATE: "bookingDate",
      BOOKING_START_DATE: "bookingStartDate",
      BOOKING_END_DATE: "bookingEndDate",
      BOOKING_START_TIME: "bookingStartTime",
      BOOKING_END_TIME: "bookingEndTime",
      DOCUMENT: "document",
    },
    ROOM_CONFIG_DESK_TAB: {
      OFFICE: "office",
      BUILDING: "building",
      FLOOR: "floor",
      ROOM_TYPE: "roomType",
      ROOM: "room",
      TYPE: "type",
      DESK_NUMBER: "deskNumber",
      PABX_NUMBER: "pabxNumber",
    },
    ROOM_CONFIG_BUILDING_TAB: {
      OFFICE: "officeAddressId",
      BUILDING: "buildingName",
      FLOOR: "floorCount",
    },
    ROOM_CONFIG: {
      ROOM_TAB: {
        OFFICE: "officeAddress",
        BUILDING: "building",
        FLOOR: "floorId",
        ROOM_TYPE: "roomType",
        ROOM_NO: "roomNo",
      },
      DESK: {
        OFFICE: "office",
        BUILDING: "building",
        FLOOR: "floor",
        ROOM_TYPE: "roomType",
        ROOM: "room",
        TYPE: "type",
        DESK_NUMBER: "deskNumber",
        PABX_NUMBER: "pabxNumber",
      },
    },

    SOFTWARE_INVENTORY: {
      SOFTWARE_NAME: "softwareName",
      PURPOSE: "purpose",
      SUPPLIER_NAME: "supplierNameId",
      SUPPLIER_CONTACT: "supplierContact",
      PURCHASE_DATE: "purchaseDate",
      GO_LIVE_DATE: "goLiveDate",
      LICENSE_TYPE: "licenseType",
      LICENSE_RENEWAL_DATE: "licenseRenewalDate",
      PRICE: "price",
      TENDER_INFO: "tenderInfo",
      WARRANTY_EXPIRE_DATE: "warrantyExpiryDate",
      WARRANTY_PERIOD: "warrantyPeriod",
      MAINTENANCE_PARTY: "maintenanceParty",
      PARTY_NAME: "partyNameId",
      MAINTENANCE_CONTACT_SIGN_OF_DATE: "maintenanceContactSignOffDate",
      MAINTENANCE_CONTACT_EXPIRE_DATE: "maintenanceContactExpiryDate",
      MAINTENANCE_CONTACT: "maintenanceContact",
      SLA: "sla",
      SUPPORTING_DOCUMENTS: "supportingDocuments",
      OWNER_FROM_ACC: "ownerFromAcc",
    },

    REQUISITION: {
      REQUESTER_TYPE: "requesterType",
      REQ_DATE: "reqDate",
      LETTER: "letter",
      FILE: "file",
    },

    PROCUREMENT: {
      NAME_EN: "nameEn",
      NAME_BN: "nameBn",
      NAME: "name",
      DETAILS: "details",
      DATE: "date",
      REF_NO: "refNo",
      REMARKS: "remarks",
      DOCUMENT: "document",
      PROCUREMENT_TYPE: "procurementType",
      INVENTORY_TYPE: "inventoryType",
      CATEGORY: "category",
      GROUP: "group",
      BRAND: "brand",
      TYPE: "type",
      PURCHASE_DATE: "purchaseDate",
      AMOUNT: "amount",
      UNIT: "unit",
      UNIT_PRICE: "unitPrice",
      VENDOR: "vendorInfo",
      LOT_NO: "lotNo",
      WARRANTY_START: "warrantyStartDate",
      WARRANTY_END: "warrantyEndDate",
      PROCUREMENT_BASE_ID: "procurementBaseId",
      UNIT_NAME: "unitName",
      ROOM_ID: "roomId",
    },

    EMPLOYEE: {
      ASSIGN_DESK_OR_BED: {
        OFFICE: "officeId",
        BUILDING: "buildingId",
        ROOM: "roomId",
        ROOM_TYPE: "roomTypeId",
        DESK_NUMBER: "deskNumberId",

        LIVES_ON_PREMISES: "lives",
        LIVES_ON_PREMISES_OFFICE: "livesOfficeId",
        LIVES_ON_PREMISES_BUILDING: "livesBuildingId",
        LIVES_ON_PREMISES_ROOM: "livesRoomId",
        LIVES_ON_PREMISES_BED_NUMBER: "livesBedNumberId",
        LIVES_ON_PREMISES_BARRACK_NUMBER: "livesBarrackNumberId",
      },
    },

    SETTINGS: {
      NAME: {
        GROUP: "groupId",
        BRAND: "brandId",
        NAME_BN: "nameBn",
        NAME_EN: "nameEn",
        TYPE: "type",
        INVENTORY_TYPE: "inventoryType",
        DESCRIPTION: "description",
      },
    },

    // Task management
  },
  TASK_DETAILS: {
    NAME_OF_TASK: "taskName",
    DETAILS: "details",
    START_DATE: "startDate",
    END_DATE: "endDate",
    PREREQUISITES: "prerequisite",
    ASSIGNED_PERSON: "responsiblePersons",
    SHARED_PERSON: "sharedWith",
    PRIORITY: "priority",
    STATUS: "status",
    REMARKS: "remarks",
    ATTACHMENTS: "documents",
  },

  SUB_TASK_DETAILS: {
    NAME_OF_SUB_TASK: "subtaskName",
    DETAILS: "details",
    START_DATE: "startDate",
    END_DATE: "endDate",
    PREREQUISITES: "prerequisite",
    ASSIGNED_PERSON: "responsiblePersons",
    SHARED_PERSON: "sharedWith",
    PRIORITY: "priority",
    STATUS: "status",
    REMARKS: "remarks",
    ATTACHMENTS: "documents",
  },

  // ticket
  E_TICKET: {
    SETTINGS: {
      STATUS: {
        NAME: "statusName",
        COLOR: "statusColor",
      },
      PRIORITY: {
        NAME: "priorityName",
        COLOR: "priorityColor",
      },
      CATEGORY: {
        NAME: "categoryName",
      },
      TYPE: {
        NAME: "typeName",
      },
    },

    TICKET_DETAILS: {
      ID: "ticket",
      TYPE: "type",
      CATEGORY: "category",
      SUBJECT: "subject",
      ISSUE_NAME: "issueName",
      ISSUE_DETAILS: "requestDetails",
      UNIT: "unit",
      POSITION: "position",
      CREATED: "createdAt",
      UPDATED: "updatedAt",
      ASSIGNED_TO: "assignedTo",
      PRIORITY: "priority",
      STATUS: "status",
      DOCUMENTS: "document",
      FROM_DATE: "from",
      TO_DATE: "to",
      UNIT_ID: "unitId",
    },

    COMMENT: {
      RICH_TEXT_EDITOR: "comment",
      COMMENT_DOC: "document",
    },
  },

  // Procurement Module
  PROCUREMENT_DETAILS: {
    NAME_BN: "nameBn",
    NAME_EN: "nameEn",
    REF_NO: "procurementRefNo",
    APP_PACKAGE_ID: "appPackageId",
    RICH_TEXT_EDITOR: "letter",
    DOCUMENTS: "procurementDocuments",
    ITEMS: "procurementItems",
    DEMAND_IDS: "procurementDemandIds",
    EXTRA_COST_INFO: "extraCostInfo",
    EXTRA_COST_AMOUNT: "extraCostAmount",
    APP_ID: "appId",
    PACKAGE_BUDGET_ID: "packageBudgetId",
    BUDGET_QUARTER: "budgetQuarter",
    PUBLISH_DATE: "publishDate",
    LAST_SUBMISSION_DATE: "lastSubmissionDate",
    COMPLETION_DATE: "completionDate",
    PACKAGE_BUDGET_QUARTER: "budgetQuarter",
    SPEC_PREPARATION: {
      DOCUMENT_NAME: "name",
      DOCUMENT_DATE: "date",
      SPEC_UPLOAD: "specDocuments",
      NAME_OF_APPROVER: "approverName",
      APPROVE_DATE: "approveDate",
      APPROVER_DOCS: "approverDocuments",
    },
    COMMITTEE_DETAILS: {
      COMMITTEE_NAME: "committeeName",
    },
    TENDER_NOTICE: {
      NOTICE_DOCUMENT: "noticeDocuments",
      PAPER_NAME: "paperName",
      PAPER_DATE: "paperDate",
      PUBLISH_NEWS_LINK: "publishedNewsLink",
      PUBLISH_WEBSITE: "isPublishedOnWebsite",
      MEETING: "isPreTenderMeeting",
      MEETING_DOCUMENT: "preTenderMeetingDocuments",
      PUBLICATION_DATE: "noticePublicationDate",
      SUBMISSION_DATE: "tenderSubmissionLastDate",
      OPENING_DATE: "tenderOpenDate",
      DELIVERY_PERIOD: "deliveryPeriodDays",
      CORRIGENDUM_DOCUMENT: "corrigendumDocuments",
    },
    TENDER_OPENING: {
      // DOCUMENT_NAME: "name",
      // DOCUMENT_DATE: "documentDate",
      OPENING_DOCUMENTS: "openingDocuments",
      VENDOR_ID: "vendorId",
      PROPOSED_PRICE: "proposedPrice",
      SECURITY_MONEY: "securityMoney",
      KEY_DOCUMENT: "vendorDocuments",
    },
    NOA: {
      ISSUE_DATE: "issueDate",
      ACCEPTED_BY_VENDOR: "isVendorAccepted",
      ACCEPTANCE_DATE: "vendorAcceptanceDate",
      PROJECT_START_DATE: "projectDurationFrom",
      PROJECT_END_DATE: "projectDurationTo",
      TENDER_SECURITY_SUBMISSION: "secMoneySubmitStatus",
      SECURITY_MONEY_SUBMISSION_DATE: "secMoneySubDate",
      SECURITY_MONEY_WITHDRAWAL_LAST_DATE: "secMoneyWithdrawnLastDate",
      SECURITY_AMOUNT_PERCENTAGE: "secMoneyAmountPercentage",
      PERFORMANCE_SECURITY_AMOUNT: "performanceSecAmount",
      SECURITY_MONEY_SUBMISSION_TYPE: "secMoneySubmissionType",
      SECURITY_MONEY_SUBMITTED_TO: "secMoneySubmittedTo",
      DOCUMENT_NAME: "documentName",
      DOCUMENT_DATE: "documentDate",
      DOCUMENT: "documents",
    },
    AGREEMENT: {
      ACC_AUTHORIZED: {
        PERSON_NAME: "accAuthorized-name",
        PERSON_EMAIL: "accAuthorized-email",
        PERSON_DESIGNATION: "accAuthorized-designation",
        PERSON_PHONE_NUMBER: "accAuthorized-phoneNumber",
        PERSON_DETAILS: "accAuthorized-details",
        PERSON_ID: "accAuthorized-employeeId",
      },
      ACC_WITNESS: {
        NAME: "name",
        EMAIL: "email",
        DESIGNATION: "designation",
        PHONE_NUMBER: "phoneNumber",
        DETAILS: "details",
      },
      VENDOR_AUTHORIZED: {
        PERSON_NAME: "vendorAuthorized-name",
        PERSON_EMAIL: "vendorAuthorized-email",
        PERSON_DESIGNATION: "vendorAuthorized-designation",
        PERSON_PHONE_NUMBER: "vendorAuthorized-phoneNumber",
        PERSON_DETAILS: "vendorAuthorized-details",
      },
      VENDOR_WITNESS: {
        NAME: "name",
        EMAIL: "email",
        DESIGNATION: "designation",
        PHONE_NUMBER: "phoneNumber",
        DETAILS: "details",
      },

      CONTACT_SIGN_DATE: "contractSignDate",
      PROJECT_COMPLETION_DATE: "projectCompletionDate",
      EXTENDED_COMPLETION_DATE: "projectExtendedCompletionDate",
      AGREEMENT_DOC_UPLOAD: "documents",
    },
    TENDER_EVOLUTION: {
      DOCUMENT_NAME: "name",
      DOCUMENT_DATE: "documentDate",
      UPLOAD: "documents",
      VENDOR_NAME: "vendorName",
      PROPOSED_PRICE: "proposedPrice",
      STATUS: "evaluationStatus",
      REMARKS: "remarks",
      SELECT_VENDOR_FOR_NOA: "selectVendorId",
      SELECTED_VENDOR_FOR_NOA: "selectedVendorId",
      TENDER_STATUS: "tenderStatus",
      TENDER_STATUS_COMMENT: "tenderStatusComments",
      VENDOR_SECTION_COMMENT: "vendorSelectionComments",
      EVALUATION_DETAILS_DOCUMENT: "evaluationDetailsDocuments",
    },
    FINAL_RECEIVING: {
      DOCUMENT_NAME: "documentName",
      DOCUMENT_DATE: "documentDate",
      DOCUMENT_MEMORANDUM: "documentMemorandumNo",
      UPLOAD: "documents",
      // REPORT_UPLOAD: "reportUpload",
      // REPORT_DATE: "reportDate",
      // REMARKS: "remarks",
      DETAILS: "details",
      REMARKS_ABOUT_SUPPLIER: "remarksAboutSupplier",
      TENDER_MONEY_RETURN: "isSecurityMoneyReturned",
      TENDER_MONEY_AMOUNT: "securityMoneyAmount",
      PERFORMANCE_MONEY_RETURN: "isPerformSecurityMoneyReturned",
      PERFORMANCE_MONEY_AMOUNT: "performSecurityMoneyAmount",
    },
  },
  PROCUREMENT_PACKAGE: {
    NAME: "title",
    PACKAGE_REF_NO: "packageRefNo",
    PACKAGE_DESCRIPTION: "packageDescription",
    FINANCIAL_CODE: "financialCode",
    PROCUREMENT_NATURE: "procurementNatureId",
    PROCUREMENT_TYPE: "procurementTypeId",
    PACKAGE_BUDGET_DETAILS: "packageBudgetDetails",
    PACKAGE_BUDGET_TITLE: "title",
    PROCUREMENT_METHOD: "procurementMethodId",
    FIRST_QUARTER_BUDGET: "firstQuarterBudget",
    SECOND_QUARTER_BUDGET: "secondQuarterBudget",
    THIRD_QUARTER_BUDGET: "thirdQuarterBudget",
    FOURTH_QUARTER_BUDGET: "fourthQuarterBudget",
    APPROVING_AUTHORITY: "approvingAuthority",
    ALLOCATED_BUDGET: "allocatedBudget",
    DOCUMENTS: "documents",
  },

  VENDOR: {
    NAME: "vendorName",
    ADDRESS: "address",
    TRADE_LICENSE_NO: "tradeLicenseNo",
    CONTACT_NO: "contactNo",
    VENDOR_TYPES: "vendorTypes",
    VENDOR_NATURE: "vendorNature",
    DOCUMENTS: "documents",
  },
};
